import request from '@/utils/request'

// 认证
export const authApi = {
  captcha: () => request.get('/auth/captcha'),
  login: (data) => request.post('/auth/login', data),
  userInfo: () => request.get('/auth/user-info'),
  logout: () => request.post('/auth/logout'),
  onlineUsers: () => request.get('/auth/online-users'),
  loginStatistics: () => request.get('/auth/login-statistics'),
  kickUser: (data) => request.post('/auth/kick', data),
  updateProfile: (data) => request.post('/auth/profile/update', data),
  changePassword: (data) => request.post('/auth/profile/change-password', data),
  unbindWx: () => request.post('/wx/unbind')
}

// 楼栋管理
export const buildingApi = {
  list: () => request.get('/buildings'),
  save: (data) => request.post('/buildings/save', data),
  update: (data) => request.post('/buildings/update', data),
  delete: (id) => request.post(`/buildings/delete/${id}`)
}

// 楼层管理
export const floorApi = {
  list: (buildingId) => request.get('/floors', buildingId ? { params: { buildingId } } : {}),
  save: (data) => request.post('/floors/save', data),
  update: (data) => request.post('/floors/update', data),
  delete: (id) => request.post(`/floors/delete/${id}`)
}

// 仪表管理
export const meterApi = {
  list: (params) => request.get('/meters', { params }),
  save: (data) => request.post('/meters/save', data),
  update: (data) => request.post('/meters/update', data),
  delete: (id) => request.post(`/meters/delete/${id}`)
}

// 收费项目
export const chargeItemApi = {
  list: (params) => request.get('/charge-items', { params }),
  save: (data) => request.post('/charge-items/save', data),
  update: (data) => request.post('/charge-items/update', data),
  delete: (id) => request.post(`/charge-items/delete/${id}`),
  batchPrice: (data) => request.post('/charge-items/batch-price', data)
}

// 抄表记录
export const readingApi = {
  list: (params) => request.get('/meter-readings', { params }),
  getLastReadings: (params) => request.get('/meter-readings/last', { params }),
  batchSave: (data) => request.post('/meter-readings/batch-save', data),
  save: (data) => request.post('/meter-readings/save', data),
  update: (data) => request.post('/meter-readings/update', data),
  delete: (id) => request.post(`/meter-readings/delete/${id}`)
}

// 账单
export const billApi = {
  list: (params) => request.get('/bills', { params }),
  detail: (id) => request.get(`/bills/detail/${id}`),
  preview: (data) => request.post('/bills/preview', data),
  generate: (data) => request.post('/bills/generate', data),
  generateWithItems: (data) => request.post('/bills/generate-with-items', data),
  generateBatch: (data) => request.post('/bills/generate-batch', data),
  updateStatus: (id, data) => request.post(`/bills/update-status/${id}`, data),
  delete: (id) => request.post(`/bills/delete/${id}`),
  overview: (params) => request.get('/bills/statistics/overview', { params }),
  monthly: (params) => request.get('/bills/statistics/monthly', { params }),
  floorStatistics: (params) => request.get('/bills/statistics/floor', { params })
}

// 角色管理
export const roleApi = {
  list: () => request.get('/roles'),
  all: () => request.get('/roles/all'),
  save: (data) => request.post('/roles/save', data),
  update: (data) => request.post('/roles/update', data),
  delete: (id) => request.post(`/roles/delete/${id}`),
  getRoleMenus: (roleId) => request.get(`/roles/menus/${roleId}`),
  saveRoleMenus: (data) => request.post('/roles/menus/save', data)
}

// 菜单管理
export const menuApi = {
  tree: () => request.get('/menus/tree'),
  all: () => request.get('/menus/all'),
  userTree: (userId) => request.get('/menus/user-tree', { params: { userId } }),
  save: (data) => request.post('/menus/save', data),
  update: (data) => request.post('/menus/update', data),
  delete: (id) => request.post(`/menus/delete/${id}`)
}

// 用户管理
export const userApi = {
  list: () => request.get('/users'),
  save: (data) => request.post('/users/save', data),
  update: (data) => request.post('/users/update', data),
  delete: (id) => request.post(`/users/delete/${id}`),
  getUserRoles: (userId) => request.get(`/users/roles/${userId}`),
  saveUserRoles: (data) => request.post('/users/roles/save', data),
  unbindWx: (userId) => request.post(`/wx/unbind/${userId}`)
}

// 仪表盘
export const dashboardApi = {
  overview: () => request.get('/dashboard')
}

// 房间管理
export const roomApi = {
  tree: () => request.get('/rooms/tree'),
  list: (params) => request.get('/rooms', { params }),
  save: (data) => request.post('/rooms/save', data),
  update: (data) => request.post('/rooms/update', data),
  delete: (id) => request.post(`/rooms/delete/${id}`),
  statistics: () => request.get('/rooms/statistics')
}

// 租客管理
export const tenantApi = {
  list: (params) => request.get('/tenants', { params }),
  save: (data) => request.post('/tenants/save', data),
  update: (data) => request.post('/tenants/update', data),
  checkout: (id) => request.post(`/tenants/checkout/${id}`),
  delete: (id) => request.post(`/tenants/delete/${id}`)
}

// 房东好物
export const goodieApi = {
  list: (params) => request.get('/goods', { params }),
  all: (params) => request.get('/goods/all', { params }),
  save: (data) => request.post('/goods/save', data),
  update: (data) => request.post('/goods/update', data),
  delete: (id) => request.post(`/goods/delete/${id}`),
  toggle: (id) => request.post(`/goods/toggle/${id}`),
  click: (id) => request.post(`/goods/click/${id}`)
}

// 反馈
export const feedbackApi = {
  submit: (data) => request.post('/feedback/submit', data),
  list: () => request.get('/feedback'),
  reply: (data) => request.post('/feedback/reply', data)
}

// 快捷小程序
export const miniAppApi = {
  list: () => request.get('/mini-apps'),
  all: () => request.get('/mini-apps/all'),
  save: (data) => request.post('/mini-apps/save', data),
  update: (data) => request.post('/mini-apps/update', data),
  delete: (id) => request.post(`/mini-apps/delete/${id}`),
  toggle: (id) => request.post(`/mini-apps/toggle/${id}`)
}

// 轮播文章
export const articleApi = {
  list: () => request.get('/articles'),
  all: () => request.get('/articles/all'),
  save: (data) => request.post('/articles/save', data),
  update: (data) => request.post('/articles/update', data),
  delete: (id) => request.post(`/articles/delete/${id}`),
  toggle: (id) => request.post(`/articles/toggle/${id}`)
}
